<template>
  <div class="service-form-view">
    <template v-if="option.group">
      <div v-for="(group, index) in option.group" :key="index" class="group-item">
        <template v-if="!group.hide">
          <div class="group-title">
            {{group.label}}
          </div>
          <div class="group-content">
            <template v-if="group.column">
              <template v-for="(item, index) in group.column">
                <div v-if="item.display !== false" :key="item.prop || index" class="form-item" :style="getItemStyle(item)">
                  <span class="label" v-if="item.label">{{item.label}}:</span>
                  <span class="input-box">
                    <template v-if="$slots[item.prop] || item.isSlot === true">
                      <slot :name="item.prop" :data="value" />
                    </template>
                    <el-tooltip v-else-if="item.tips" effect="dark" :content="getShowValue(item, value)" placement="top">
                      <span>{{getShowValue(item, value)}}</span>
                    </el-tooltip>
                    <span v-else>{{getShowValue(item, value)}}</span>
                  </span>
                </div>
              </template>
            </template>
          </div>
        </template>
      </div>
    </template>
    <template v-if="option.column">
      <template v-for="(item, index) in option.column">
        <div v-if="item.display !== false" :key="item.prop || index" class="form-item" :style="getItemStyle(item)">
          <span class="label" v-if="item.label">{{item.label}}:</span>
          <span class="input-box">
            <template v-if="$slots[item.prop] || item.isSlot === true">
              <slot :name="item.prop" :data="value" />
            </template>
            <el-tooltip v-else-if="item.tips" effect="dark" :content="getShowValue(item, value)" placement="top">
              <span>{{getShowValue(item, value)}}</span>
            </el-tooltip>
            <span v-else>{{getShowValue(item, value)}}</span>
          </span>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorObj: {}
    }
  },
  props: {
    option: Object,
    value: Object,
    hidden: Boolean
  },
  methods: {
    getItemStyle(item) {
      const css = {}
      if (this.$slots[item.prop]) {
        css.height = 'auto'
      }
      if (item.span === 24) {
        css.width = '100%'
        css.wordBreak = 'break-all'
        css.whiteSpace = 'normal'
      }
      if (item.span === 16) {
        css.width = '300px'
      }
      if (item.flex) {
        css.display = 'flex'
      }
      if (item.type === 'textarea') {
        css.height = 'auto'
      }
      item.width && (css.width = item.width)
      item.height && (css.height = item.height)
      item.right && (css.paddingRight = item.right)
      item.bottom && (css.marginBottom = item.bottom)
      item.block && (css.float = 'none')
      return css
    },
    handleInput(item, val) {
      const data = { ...this.value }
      data[item.prop] = val
      this.$emit('input', data)
      if (typeof item.change === 'function') {
        item.change({
          valueObj: {},
          value: val
        })
      }
      this.handleRule(item, val, 'input')
    },
    handleBlur(item, val) {
      const data = { ...this.value }
      data[item.prop] = val
      this.handleRule(item, val, 'blur')
    },
    handleRule(item, val = '', type) {
      if (!item) {
        return
      }
      this.errorObj[item.prop] = ''
      if (item.rules && item.rules.length) {
        item.rules.map(rule => {
          if (~rule.trigger.indexOf(type)) {
            if (rule.validator && typeof rule.validator === 'function') {
              // 不确定回传rule 是什么 {}
              rule.validator({}, val, err => {
                if (err) {
                  this.errorObj = {
                    ...this.errorObj,
                    [item.prop]: err.toString().replace('Error: ', '')
                  }
                }
              })
            }
            let required = ''
            if (val.constructor === String) {
              required = !val.trim()
            } else {
              required = val === undefined || val === null
            }
            if (rule.required && required && item.display !== false) {
              this.errorObj = {
                ...this.errorObj,
                [item.prop]: rule.message
              }
            }
          }
        })
      }
    },
    validate(cb) {
      if (this.option.group) {
        this.option.group.map(o => {
          o.column &&
            o.column.map(item => {
              this.handleRule(item, this.value[item.prop], 'blur')
            })
        })
      }
      this.option.column &&
        this.option.column.map(item => {
          this.handleRule(item, this.value[item.prop], 'blur')
        })
      cb && cb(!Object.values(this.errorObj).filter(o => o).length)
    },
    getShowValue(item, value) {
      let val = ''
      if (item.formatter && typeof item.formatter === 'function') {
        val = item.formatter(value)
      } else {
        val = value[item.prop]
      }
      return (val || '--') + ''
    }
  }
}
</script>

<style lang="scss" scoped>
.service-form-view {
  .group-item {
    display: flex;
    margin-bottom: 20px;

    .group-title {
      font-size: 14px;
      line-height: 20px;
      color: #666;
      border: 1px solid #ddd;
      @include text-color('subtitle');
      @include border-color('lighter');
      @include bg-color('light');
      width: 20px;
      padding: 5px;
      text-align: center;
      font-weight: 600;
    }
    .group-content {
      flex: 1;
      margin-left: 10px;
      margin-bottom: -12px;

    }
  }

  .form-item {
        box-sizing: border-box;
        float: left;
        padding-right: 20px;
        margin-bottom: 12px;
        // height: 24px;
        width: 170px;
        align-items: center;
        overflow: hidden;
        white-space: nowrap;
        &.block-item {
          width: 100%;
        }
        // &:after {
        //   content: '';
        //   display: inline-block;
        //   height: 100%;
        //   width: 0;
        //   vertical-align: middle;
        // }
        .label {
          display: block;
          white-space: nowrap;
          line-height: 24px;
          @include text-color('subtitle');
          &.required:before {
            content: '*';
            color: #f56c6c;
          }
        }
        .input-box {
          width: 100%;
          height: 100%;
          line-height: 24px;
        }
      }
  .btn-view {
    padding-top: 20px;
    text-align: right;
  }
}
</style>
<style lang="scss">
.service-form-view {
  margin-right: -20px;
  .is-error {
    input,
    textarea {
      border: 1px solid #f56c6c;
    }
  }
  .cp-input .el-input {
    width: 200px;
  }
  .el-input {
    width: 150px;
    height: 24px;
    input {
      height: 24px;
      line-height: 24px;
    }
    .el-input__icon {
      line-height: 24px;
    }
    .el-icon-circle-close {
      top: 6px;
    }
  }
  .el-textarea {
    textarea {
      resize: none;
    }
  }
  .el-radio {
    margin-right: 10px !important;
  }
}
</style>
